let lenisInstance = null;

export const setLenis = (l) => {
  lenisInstance = l;
};

export const scrollToId = (selector) => {
  if (lenisInstance) {
    lenisInstance.scrollTo(selector, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(selector)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToTop = () => {
  if (lenisInstance) {
    lenisInstance.scrollTo(0, { duration: 1.4 });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
